import React, { useState } from 'react'
import { Tooltip, Badge, BadgeProps } from 'antd'
import { useSelector, shallowEqual } from 'dva'
import './index.less'

const getImgUrl = name => require('./images/' + name + '.png')

const list = ['card', 'iphone', 'top']

const selector = ({ cart, loading }) => ({
  amount: cart.amount || 0,
})
export default function FloatButton() {
  const { amount } = useSelector(selector, shallowEqual)

  const buttonClick = key => {
    // 购物车
    if (key === 'card') window.open('/cart')
    // 回到顶部
    if (key === 'top') {
      document.documentElement.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <div className="float-button">
      {list.map((item, index) => (
        <Item
          key={index}
          name={item}
          clickHandle={buttonClick}
          badge={item === 'card'}
          badgeProps={{
            count: amount,
            showZero: true,
          }}
          tooltip={item === 'iphone'}
        />
      ))}
    </div>
  )
}

interface IconProps {
  name?: React.ReactNode
  activate?: boolean
}

// 图标
const Icon = ({ name, activate }: IconProps) => {
  return <img src={getImgUrl(`${name}${activate ? '_on' : ''}`)} alt="" />
}

interface ItemProps extends IconProps {
  clickHandle?: Function
  tooltip?: boolean
  badge?: boolean
  badgeProps?: BadgeProps
}

const Item = ({ clickHandle, name, tooltip, badge, badgeProps }: ItemProps) => {
  const [hasMouse, setHasMouse] = useState(false)

  // 提示
  if (tooltip) {
    return (
      <Tooltip
        trigger="click"
        title={<TooltipTitle />}
        color="#fff"
        placement="left"
      >
        <div
          className="float-button-item"
          onMouseOver={() => setHasMouse(true)}
          onMouseOut={() => setHasMouse(false)}
          onClick={() => clickHandle?.(name)}
        >
          <Icon name={name} activate={hasMouse} />
        </div>
      </Tooltip>
    )
  }

  // 角标
  if (badge) {
    return (
      <div
        className="float-button-item"
        onMouseOver={() => setHasMouse(true)}
        onMouseOut={() => setHasMouse(false)}
        onClick={() => clickHandle?.(name)}
      >
        <Badge {...badgeProps}>
          <Icon name={name} activate={hasMouse} />
        </Badge>
      </div>
    )
  }

  if (tooltip && badge) {
    return (
      <Tooltip
        trigger="click"
        title={name === 'iphone' && <TooltipTitle />}
        color="#fff"
        placement="left"
      >
        <div
          className="float-button-item"
          onMouseOver={() => setHasMouse(true)}
          onMouseOut={() => setHasMouse(false)}
          onClick={() => clickHandle?.(name)}
        >
          <Badge count={5}>
            <Icon name={name} activate={hasMouse} />
          </Badge>
        </div>
      </Tooltip>
    )
  }

  return (
    <div
      className="float-button-item"
      onMouseOver={() => setHasMouse(true)}
      onMouseOut={() => setHasMouse(false)}
      onClick={() => clickHandle?.(name)}
    >
      <Icon name={name} activate={hasMouse} />
    </div>
  )
}

const TooltipTitle = () => {
  return (
    <div className="f-b-tooltip-title">
      <p>联系电话</p>
      <p className="f-b-phone">023-6531 6297</p>
      <p>工作时间：9:00-18:00</p>
    </div>
  )
}
